import { render, staticRenderFns } from "./maintenance-and-risk.vue?vue&type=template&id=c6251ea2&scoped=true"
import script from "./maintenance-and-risk.vue?vue&type=script&lang=ts"
export * from "./maintenance-and-risk.vue?vue&type=script&lang=ts"
import style0 from "./maintenance-and-risk.vue?vue&type=style&index=0&id=c6251ea2&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6251ea2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6251ea2')) {
      api.createRecord('c6251ea2', component.options)
    } else {
      api.reload('c6251ea2', component.options)
    }
    module.hot.accept("./maintenance-and-risk.vue?vue&type=template&id=c6251ea2&scoped=true", function () {
      api.rerender('c6251ea2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/maintenance-and-risk/maintenance-and-risk.vue"
export default component.exports